import { LoadState } from "../../constants/enums";
import { initialLead, initialLeadFollowUp, initialLeadState } from "./leads.types";

import { createSlice } from "@reduxjs/toolkit";
import { fetchLeads, fetchLeadFollowUp, fetchLeadFollowUpsList, fetchLeadsList, upsertLead, upsertLeadFollowUp } from "./leadsThunk";
import { APIError } from "../../constants/types";

const leadsSlice = createSlice({
  name: "leads",
  initialState: initialLeadState,
  reducers: {
    clearLeadState: (state) => {
      state.leads = initialLeadState.leads;
    },
    clearLead: (state) => {
      state.leads.leadLoading = LoadState.NotLoaded;
      state.leads.lead = initialLead;
    },
    clearLeadFollowUpState: (state) => {
      state.followUps = initialLeadState.followUps;
    },
    clearLeadFollowUp: (state) => {
      state.followUps.followUpLoading = LoadState.NotLoaded;
      state.followUps.followUp = initialLeadFollowUp;
    },
  },
  extraReducers: (builder) => {
    builder
      // Leads
      .addCase(fetchLeadsList.pending, (state) => {
        state.leads.loading = LoadState.InProgress;
        state.leads.list = [];
      })
      .addCase(fetchLeadsList.fulfilled, (state, action) => {
        state.leads.loading = LoadState.Loaded;
        state.leads.list = action.payload.data;
      })
      .addCase(fetchLeadsList.rejected, (state) => {
        state.leads.loading = LoadState.Failed;
        state.leads.list = [];
      })
      .addCase(fetchLeads.pending, (state) => {
        state.leads.leadLoading = LoadState.InProgress;
        state.leads.lead = initialLead;
      })
      .addCase(fetchLeads.fulfilled, (state, action) => {
        state.leads.leadLoading = LoadState.Loaded;
        state.leads.lead = action.payload;
      })
      .addCase(fetchLeads.rejected, (state, action) => {
        state.leads.leadLoading = LoadState.Failed;
        state.leads.error = (action.payload as APIError).message;
      })
      // Follow-ups
      .addCase(fetchLeadFollowUpsList.pending, (state) => {
        state.followUps.loading = LoadState.InProgress;
        state.followUps.list = [];
        state.followUps.totalRecords = 0;
      })
      .addCase(fetchLeadFollowUpsList.fulfilled, (state, action) => {
        state.followUps.loading = LoadState.Loaded;
        state.followUps.list = action.payload.data;
        state.followUps.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchLeadFollowUpsList.rejected, (state) => {
        state.followUps.loading = LoadState.Failed;
        state.followUps.list = [];
        state.followUps.totalRecords = 0;
      })
      .addCase(fetchLeadFollowUp.pending, (state) => {
        state.followUps.followUpLoading = LoadState.InProgress;
        state.followUps.followUp = initialLeadFollowUp;
      })
      .addCase(fetchLeadFollowUp.fulfilled, (state, action) => {
        state.followUps.followUpLoading = LoadState.Loaded;
        state.followUps.followUp = action.payload;
      })
      .addCase(fetchLeadFollowUp.rejected, (state, action) => {
        state.followUps.followUpLoading = LoadState.Failed;
        state.followUps.error = (action.payload as APIError).message;
      })
      .addCase(upsertLead.fulfilled, (state, action) => {
        if (action.payload.customer_id) {
          state.leads.lead = {
            ...state.leads.lead,
            customer_id: String(action.payload.customer_id),
          };
        }
      })
      .addCase(upsertLeadFollowUp.pending, (state) => {
        state.followUps.followUpLoading = LoadState.InProgress;
      });
  },
});

export const { clearLeadState, clearLead, clearLeadFollowUpState, clearLeadFollowUp } = leadsSlice.actions;

export const leadsReducer = leadsSlice.reducer;
